<style lang="scss" scoped>
.alert {
  padding: 20px 25px;
  color: #4a4a4a;
  margin: 0 0 20px 0;
}
.title {
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 18px;
}
.text {
  font-size: 12px;
  line-height: 26px;
}
</style>

<template>
  <div class="alert" :style="{background:color}">
    <div class="title">{{title}}</div>
    <div class="text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示',
    },
    color: {
      type: String,
      default: '#E5F8FF',
    },
  },
  components: {},
  computed: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
